import { create } from 'zustand';

interface GlobalStore {
  isLoading: boolean;
  collapsed: boolean;
  setIsLoading: (isLoading: boolean) => void;
  toggleCollapsed: () => void;
  is_processed: boolean;
  setIsProcessed: (is_processed: boolean) => void;
}

export const useGlobalStore = create<GlobalStore>(set => ({
  isLoading: false,
  collapsed: false,
  is_processed: true,

  setIsLoading: (isLoading: boolean) => set({ isLoading }),

  toggleCollapsed: () => set(state => ({ collapsed: !state.collapsed })),

  setIsProcessed: (is_processed: boolean) => {
    if (is_processed) {
      set({ is_processed: true });
    } else {
      const timeoutId = setTimeout(() => {
        set({ is_processed: false });
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  },
}));
